import { Outlet } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { AppShell } from "../chrome/AppShell";
import { MarketingFooter } from "../chrome/MarketingFooter";
import { MarketingNav } from "../chrome/MarketingNav";

// React Router 7 port of `components/MarketingShell.tsx`. Anonymous
// visitors get the marketing chrome (nav + footer); signed-in visitors
// see the same info pages inside the app shell so they don't drop out
// of the sidebar/topbar chrome. While auth is resolving we render the
// marketing chrome — it's the safer default for unauthenticated traffic
// and crawlers, matching the original Next.js component.
export function MarketingShell() {
  const { user, loading } = useAuth();

  if (!loading && user) {
    return (
      <AppShell>
        <div className="info-in-app">
          <Outlet />
        </div>
      </AppShell>
    );
  }

  return (
    <>
      <MarketingNav />
      <Outlet />
      <MarketingFooter />
    </>
  );
}
